export default __webpack_public_path__ + "static/media/tim_table.e83b8c50.png";